import React from 'react';
import { FormData, WorkerInfo, EmploymentType, WorkerAttribute } from '../types/formTypes';

interface WorkerListFormProps {
  formData: FormData;
  updateFormData: (updates: Partial<FormData>) => void;
}

const WorkerListForm: React.FC<WorkerListFormProps> = ({ formData, updateFormData }) => {
  const addWorker = () => {
    const newWorker: WorkerInfo = {
      id: Date.now().toString(),
      name: '',
      insuranceNumber: { part1: '', part2: '', part3: '' },
      employmentType: '正規雇用労働者等',
      workerAttribute: '新規学卒予定者以外',
    };
    updateFormData({ workers: [...formData.workers, newWorker] });
  };

  const updateWorker = (id: string, updates: Partial<WorkerInfo>) => {
    const updatedWorkers = formData.workers.map(worker =>
      worker.id === id ? { ...worker, ...updates } : worker
    );
    updateFormData({ workers: updatedWorkers });
  };

  const removeWorker = (id: string) => {
    const updatedWorkers = formData.workers.filter(worker => worker.id !== id);
    updateFormData({ workers: updatedWorkers });
  };

  return (
    <div className="form-section">
      <h2>4. 対象労働者一覧</h2>
      
      <button type="button" onClick={addWorker} className="add-button">
        労働者を追加
      </button>

      {formData.workers.map((worker, index) => (
        <div key={worker.id} className="worker-item">
          <h3>労働者 {index + 1}</h3>
          
          <div className="form-group">
            <label>氏名 *</label>
            <input
              type="text"
              value={worker.name}
              onChange={(e) => updateWorker(worker.id, { name: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label>雇用保険被保険者番号 *</label>
            <div className="insurance-number">
              <input
                type="text"
                value={worker.insuranceNumber.part1}
                onChange={(e) => updateWorker(worker.id, {
                  insuranceNumber: { ...worker.insuranceNumber, part1: e.target.value }
                })}
                maxLength={4}
                placeholder="0000"
                required
              />
              <span>-</span>
              <input
                type="text"
                value={worker.insuranceNumber.part2}
                onChange={(e) => updateWorker(worker.id, {
                  insuranceNumber: { ...worker.insuranceNumber, part2: e.target.value }
                })}
                maxLength={6}
                placeholder="000000"
                required
              />
              <span>-</span>
              <input
                type="text"
                value={worker.insuranceNumber.part3}
                onChange={(e) => updateWorker(worker.id, {
                  insuranceNumber: { ...worker.insuranceNumber, part3: e.target.value }
                })}
                maxLength={1}
                placeholder="0"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>雇用形態 *</label>
            <select
              value={worker.employmentType}
              onChange={(e) => updateWorker(worker.id, { employmentType: e.target.value as EmploymentType })}
            >
              <option value="正規雇用労働者等">正規雇用労働者等</option>
              <option value="有期契約労働者等">有期契約労働者等</option>
            </select>
          </div>

          <div className="form-group">
            <label>対象労働者の属性 *</label>
            <select
              value={worker.workerAttribute}
              onChange={(e) => updateWorker(worker.id, { workerAttribute: e.target.value as WorkerAttribute })}
            >
              <option value="新規学卒予定者">新規学卒予定者</option>
              <option value="新規学卒予定者以外">新規学卒予定者以外</option>
            </select>
          </div>

          {worker.workerAttribute === '新規学卒予定者' && (
            <div className="form-group">
              <label>採用予定日</label>
              <div className="date-input">
                <input
                  type="text"
                  value={worker.expectedHireDate?.year || ''}
                  onChange={(e) => updateWorker(worker.id, {
                    expectedHireDate: {
                      year: e.target.value,
                      month: worker.expectedHireDate?.month || '',
                      day: worker.expectedHireDate?.day || ''
                    }
                  })}
                  placeholder="年"
                  maxLength={4}
                />
                <span>年</span>
                <input
                  type="text"
                  value={worker.expectedHireDate?.month || ''}
                  onChange={(e) => updateWorker(worker.id, {
                    expectedHireDate: {
                      year: worker.expectedHireDate?.year || '',
                      month: e.target.value,
                      day: worker.expectedHireDate?.day || ''
                    }
                  })}
                  placeholder="月"
                  maxLength={2}
                />
                <span>月</span>
                <input
                  type="text"
                  value={worker.expectedHireDate?.day || ''}
                  onChange={(e) => updateWorker(worker.id, {
                    expectedHireDate: {
                      year: worker.expectedHireDate?.year || '',
                      month: worker.expectedHireDate?.month || '',
                      day: e.target.value
                    }
                  })}
                  placeholder="日"
                  maxLength={2}
                />
                <span>日</span>
              </div>
            </div>
          )}

          <div className="form-group">
            <label>所属事業主名（出向者等の場合）</label>
            <input
              type="text"
              value={worker.affiliatedCompanyName || ''}
              onChange={(e) => updateWorker(worker.id, { affiliatedCompanyName: e.target.value })}
            />
          </div>

          <button
            type="button"
            onClick={() => removeWorker(worker.id)}
            className="remove-button"
          >
            削除
          </button>
        </div>
      ))}

      {formData.workers.length >= 24 && (
        <p className="warning">最大24名まで入力可能です。</p>
      )}
    </div>
  );
};

export default WorkerListForm;